import React, { Component } from 'react';
import './Home.css';
import { Search } from '../components/Search';
import { TileContainer } from '../components/TileContainer';

export class Home extends Component {
    constructor(props) {
        super(props);
        this.tileContainer = React.createRef();
    }
    render() {
        return (
            <div>
                <div className="header-image">
                    <div className="header-image-content">
                        <div className="center-content">
                            <div className="content">
                                <p className="pre-text">Welcome to the USAA Open Source Community</p>
                                <h1>Innovate and Build with USAA</h1>
                                <p>USAA believes that innovation is improved through contribution and collaboration. We are dedicated to helping the community shape a better future and change the way the world operates.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-content">
                    <Search onChange={(term) => this.searchUpdated(term)} />
                    <TileContainer ref={this.tileContainer} />
                </div>
            </div>
        );
    }
    searchUpdated(term) {
        this.tileContainer.current.handleSearch(term);
    }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js